<div class="cdw-overlay-backdrop" [class.blur]="blur"></div>
<div class="cdw-overlay-content" [ngClass]="sizeClass">
  <ng-content></ng-content>
</div>
